export default __webpack_public_path__ + "static/media/17.5cc186ae.jpg";